import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { useMerchandisingWrite } from './useMerchandisingWrite';

const PendingRow: React.FC<{ operationKey: string; enabled: boolean; onSaved: () => void }> = ({ operationKey, enabled, onSaved }) => {
  const write = useMerchandisingWrite(operationKey);
  const pending = write.pending;
  if (!pending) return null;
  const label = operationKey.startsWith('outlet:') ? `Outlet 調貨 #${pending.body.outlet_item_id} · ${pending.body.qty} 件 · 售價 ${pending.body.store_price}`
    : operationKey.startsWith('placement:') ? '實際陳列登記'
      : operationKey.startsWith('fitting:') ? '試穿結果登記'
        : operationKey === 'weekly-plan' ? '儲存陳列版本' : operationKey === 'planning' ? '補貨與試賣規劃' : operationKey.startsWith('demand:') ? '客人需求記錄' : '衣架設定';
  const retry = async () => {
    if (enabled && await write.submit(pending.method, pending.path, pending.body)) onSaved();
  };
  return <Alert severity="warning" sx={{ my: 1 }} action={<Button size="small" disabled={!enabled || write.busy} onClick={retry}>重試同一筆</Button>}>
    <Typography variant="body2">{label}尚待確認；會使用原來的操作編號與內容。</Typography>
    {write.error && <Typography variant="caption">{write.error}</Typography>}
  </Alert>;
};

const MerchandisingPendingWrites: React.FC<{ enabled: boolean; onSaved: () => void }> = ({ enabled, onSaved }) => {
  let keys: string[] = [];
  try { keys = Object.keys(sessionStorage).filter((key) => key.startsWith('noke-merchandising-write:') && !key.startsWith('noke-merchandising-write:inventory-count:')).map((key) => key.replace('noke-merchandising-write:', '')); } catch { /* storage unavailable */ }
  return <Box>{keys.map((key) => <PendingRow key={key} operationKey={key} enabled={enabled} onSaved={onSaved} />)}</Box>;
};

export default MerchandisingPendingWrites;
